// extracted by mini-css-extract-plugin
export default {"mainFooter":"Footer_mainFooter__Vo1MX","mainFooterDiv":"Footer_mainFooterDiv__3CiVA","headLink":"Footer_headLink__634Ug","link":"Footer_link__yvgti"};